import React from 'react';
import { PREMIUM_FEATURES } from '../config/freemiumConfig';
import './PaywallOverlay.css';

// Overlay das über gelockte Inhalte gelegt wird
// onUpgrade → wird später mit StoreKit/RevenueCat verbunden
function PaywallOverlay({ title, onUpgrade, onClose }) {
  return (
    <div className="paywall-overlay" onClick={onClose}>
      <div className="paywall-sheet" onClick={e => e.stopPropagation()}>
        <div className="paywall-handle" />

        <div className="paywall-header">
          <span className="paywall-icon">⭐</span>
          <h2 className="paywall-title">{title || 'Bullivo Pro'}</h2>
          <p className="paywall-subtitle">Schalte alle Features frei</p>
        </div>

        <div className="paywall-features">
          {PREMIUM_FEATURES.map((f, i) => (
            <div key={i} className="paywall-feature">
              <span className="paywall-feature-icon">{f.icon}</span>
              <div>
                <span className="paywall-feature-title">{f.title}</span>
                <span className="paywall-feature-desc">{f.desc}</span>
              </div>
            </div>
          ))}
        </div>

        <button className="paywall-cta" onClick={onUpgrade}>
          Pro freischalten
        </button>

        <p className="paywall-legal">
          Ab 2,99 € / Monat · Jederzeit kündbar
        </p>

        {onClose && (
          <button className="paywall-close" onClick={onClose}>
            Später
          </button>
        )}
      </div>
    </div>
  );
}

// Stitch-Style Locked Section für limitierte Listen
export function PaywallBanner({ count, onUpgrade }) {
  return (
    <div className="pw-locked-section" onClick={onUpgrade}>
      <div className="pw-locked-blur" />
      <div className="pw-locked-content">
        <div className="pw-locked-icon-wrap">
          <div className="pw-locked-icon-glow" />
          <div className="pw-locked-icon-circle">
            <span className="material-symbols-rounded pw-locked-icon-lock">lock</span>
          </div>
        </div>
        <h4 className="pw-locked-title">+{count} weitere Signale</h4>
        <p className="pw-locked-desc">Schalte den vollen Marktzugriff und exklusive KI-Empfehlungen frei.</p>
        <button className="pw-locked-btn">Upgrade auf Pro</button>
      </div>
    </div>
  );
}

export default PaywallOverlay;
